var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbsent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.14 5.856C26.332 -1.952 13.668 -1.952 5.856 5.856C-1.952 13.668 -1.952 26.332 5.856 34.144C13.668 41.952 26.332 41.952 34.14 34.144C41.952 26.332 41.952 13.668 34.14 5.856ZM10.516 10.52C14.948 6.088 21.704 5.42 26.852 8.488L8.488 26.852C5.42 21.704 6.088 14.948 10.516 10.52ZM29.48 29.48C25.048 33.912 18.296 34.58 13.148 31.512L31.512 13.148C34.58 18.296 33.912 25.052 29.48 29.48Z",
    fill: "#FF3B30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbsent);
export default __webpack_public_path__ + "static/media/absent.532216eed2cf4750e4e8b0c58d568f30.svg";
export { ForwardRef as ReactComponent };